import { uuid } from '../utils'
import quo from '../providers/quotings-config'
import inv from '../providers/inv-config'
import cn from '../providers/cn-config'
import ocop from '../providers/ocop-config'
import po from '../providers/po-config'
import bl from '../providers/bl-config'
import bcn from '../providers/bcn-config'
import tr from '../providers/tr-config'
import aj from '../providers/aj-config'
import infobr from '../providers/infobr-config'
import infoprdc from '../providers/infoprdc-config'
import infocsr from '../providers/infocsr-config'
import infospl from '../providers/infospl-config'
import infowh from '../providers/infowh-config'
import infoempl from '../providers/infoempl-config'

function convert (state, target) {
  if (target.inputs) {
    state.inputs = target.inputs.slice().map(item => {
      item = { ...item, hash: uuid() }
      return item
    })
  }

  if (target.lines) {
    state.lines = target.lines.slice().map(item => {
      item = { ...item, hash: uuid() }
      return item
    })
  }
}

function typeChange (type) {
  switch (type) {
    case 'Draft':
      return 'draft'
    case 'Approved':
    case 'Closed':
    case 'Voided':
      return 'approve'
    default:
      return type
  }
}

export default {
  namespaced: true,
  state: {
    inputs: [],
    lines: [],
    footer: {
      amount: false,
      price: false,
      tax: false
    }
  },
  mutations: {
    setQuotings: (state, type) => {
      convert(state, quo[typeChange(type)])
    },
    setOcop: (state, type) => {
      convert(state, ocop[typeChange(type)])
    },
    setInv: (state, type) => {
      convert(state, inv[typeChange(type)])
      state.footer.amount = true
      state.footer.price = true
      state.footer.tax = true
    },
    setCN: (state, type) => {
      convert(state, cn[typeChange(type)])
      state.footer.amount = true
      state.footer.price = true
      state.footer.tax = true
    },
    setPO: (state, type) => {
      convert(state, po[typeChange(type)])
      state.footer.amount = true
      state.footer.price = true
      state.footer.tax = true
    },
    setBL: (state, type) => {
      convert(state, bl[typeChange(type)])
      state.footer.amount = true
      state.footer.price = true
      state.footer.tax = true
    },
    setBCN: (state, type) => {
      convert(state, bcn[typeChange(type)])
      state.footer.amount = true
      state.footer.price = true
      state.footer.tax = true
    },
    setTR: (state, type) => {
      convert(state, tr[typeChange(type)])
      state.footer.amount = true
    },
    setAJ: (state, type) => {
      convert(state, aj[typeChange(type)])
      state.footer.amount = true
    },
    setInfoBr: (state, type) => {
      convert(state, infobr[typeChange(type)])
    },
    setInfoPrdc: (state, type) => {
      convert(state, infoprdc[type])
    },
    setInfoCsr: (state, type) => {
      convert(state, infocsr[type])
    },
    setInfoSpl: (state, type) => {
      convert(state, infospl[type])
    },
    setInfoWh: (state, type) => {
      convert(state, infowh[type])
    },
    setInfoEmpl: (state, type) => {
      convert(state, infoempl[type])
    }
  }
}
